import styled from "@emotion/styled";
import { FormInstance, UploadFile } from "antd";
import { FC } from "react";
import CampaignImageCard from "../CreateCampaign/CampaignImageCard";
import CampaignDescriptionForm from "../CreateCampaign/CampaignDescriptionForm";
import CampaignSubImageCard from "../CreateCampaign/CampaignSubImageCard";
import { DataResponseNewsProductList } from "services/interface/news/news.interface";

interface MainUpdateCampaignProps {
  form: FormInstance;
  setCheckIsActive: (checkIsActive: boolean) => void;
  checkIsActive: boolean;
  images: UploadFile[] | undefined;
  subimage: UploadFile[] | undefined;
  setContent: (content: string) => void;
  content: string;
  start_date: any,
  end_date: any,
  productList: DataResponseNewsProductList[]
}

const MainUpdateCampaign: FC<MainUpdateCampaignProps> = ({
  form,
  images,
  subimage,
  checkIsActive,
  setCheckIsActive,
  content,
  setContent,
  start_date,
  end_date,
  productList
}) => {
  return (
    <FormWrapper>
      {images && ( <CampaignImageCard is_active={checkIsActive}  setCheckIsActive={setCheckIsActive} /> )}
      {subimage && ( <CampaignSubImageCard is_active={checkIsActive}  setCheckIsActive={setCheckIsActive} /> )}
      <CampaignDescriptionForm 
        content={content} 
        setContent={setContent} 
        setCheckIsActive={setCheckIsActive} 
        is_active={checkIsActive}
        start_date={start_date}
        end_date={end_date}
        productList={productList}
       />
    </FormWrapper>
  );
};

export default MainUpdateCampaign;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #efefefef;
`;
